var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "immersive": ""
    },
    on: {
      "close": function close($event) {
        return _vm.hideModal({
          result: false
        });
      }
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "profile-offer-hero"
  }, [_c('svg', {
    staticClass: "profile-offer-art",
    attrs: {
      "viewBox": "0 0 240 150",
      "aria-hidden": "true",
      "focusable": "false"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "120",
      "cy": "87",
      "rx": "105",
      "ry": "58",
      "fill": "#eeebff"
    }
  }), _c('rect', {
    attrs: {
      "x": "62",
      "y": "18",
      "width": "113",
      "height": "115",
      "rx": "12",
      "fill": "white",
      "stroke": "#d9d2f1",
      "transform": "rotate(-6 118 75)"
    }
  }), _c('circle', {
    attrs: {
      "cx": "95",
      "cy": "53",
      "r": "13",
      "fill": "#b6a0ed"
    }
  }), _c('path', {
    attrs: {
      "d": "M75 83c0-23 40-23 40 0",
      "fill": "#b6a0ed"
    }
  }), _c('path', {
    attrs: {
      "d": "M127 48h27m-27 13h20M83 100h65m-65 12h45",
      "stroke": "#9b8dc2",
      "stroke-width": "5",
      "stroke-linecap": "round"
    }
  }), _c('rect', {
    attrs: {
      "x": "22",
      "y": "86",
      "width": "62",
      "height": "43",
      "rx": "7",
      "fill": "#f4cf96"
    }
  }), _c('path', {
    attrs: {
      "d": "m25 91 28 20 28-20",
      "fill": "none",
      "stroke": "#b97c36",
      "stroke-width": "3",
      "stroke-linejoin": "round"
    }
  }), _c('circle', {
    attrs: {
      "cx": "181",
      "cy": "102",
      "r": "25",
      "fill": "#327b65",
      "stroke": "white",
      "stroke-width": "6"
    }
  }), _c('path', {
    attrs: {
      "d": "m170 102 8 8 15-17",
      "fill": "none",
      "stroke": "white",
      "stroke-width": "4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "m195 33 3 8 8 3-8 3-3 8-3-8-8-3 8-3Z",
      "fill": "#b6a0ed"
    }
  })]), _c('p', {
    staticClass: "profile-offer-success"
  }, [_vm._v("La fiche de " + _vm._s(_vm.params.customer.name) + " est créée")]), _c('h3', {
    staticClass: "text-h5 mb-2"
  }, [_vm._v("Et si votre client la complétait ?")]), _c('p', {
    staticClass: "text-body-2 mb-0"
  }, [_vm._v("Coordonnées, facturation, livraison : demandez-lui de vérifier ses informations.")])]), _c('ol', {
    staticClass: "profile-offer-steps"
  }, [_c('li', [_c('span', {
    staticClass: "profile-offer-number"
  }, [_vm._v("1")]), _c('div', [_c('b', [_vm._v("Vous préparez l’email")]), _c('p', [_vm._v("Vérifiez le destinataire et le message avant l’envoi.")])])]), _c('li', [_c('span', {
    staticClass: "profile-offer-number"
  }, [_vm._v("2")]), _c('div', [_c('b', [_vm._v("Il complète sa fiche")]), _c('p', [_vm._v("Depuis un lien sécurisé ou son espace Safetee.")])])]), _c('li', [_c('span', {
    staticClass: "profile-offer-number"
  }, [_vm._v("3")]), _c('div', [_c('b', [_vm._v("Vous êtes informé")]), _c('p', [_vm._v("Sa confirmation met sa fiche à jour.")])])])]), _c('details', {
    staticClass: "profile-offer-details"
  }, [_c('summary', [_vm._v("Le lien, les relances et le compte Safetee")]), _c('p', [_vm._v("Le lien est valable 14 jours, avec deux relances incluses. Après confirmation, votre client pourra créer son compte et rejoindre votre organisation sur Safetee. Vous en serez informé.")])]), _c('p', {
    staticClass: "profile-offer-reassurance"
  }, [_vm._v("Rien n’est envoyé à cette étape. Vous pourrez aussi le faire plus tard depuis sa fiche.")]), _c('div', {
    staticClass: "profile-offer-actions"
  }, [_c('Button', {
    attrs: {
      "text": "Préparer la demande"
    },
    on: {
      "click": function click($event) {
        return _vm.hideModal({
          result: true
        });
      }
    }
  })], 1)])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }